import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Start Category
export const getCategoriesReceptionService = (params) => {
  return http.get(`${base_url}/reception/category`, { params });
};
export const createCategoryReceptionService = (data) => {
  return http.post(`${base_url}/reception/category`, data);
};
export const editCategoryReceptionService = (data) => {
  return http.put(`${base_url}/reception/category/${data.id}`, data);
};
export const deleteCategoryReceptionService = (id) => {
  return http.delete(`${base_url}/reception/category/${id}`);
};
export const changeCategoryActiveReceptionService = (id) => {
  return http.patch(`${base_url}/reception/category/${id}/active`);
};
// End Category

// Start Product
export const getProductsReceptionService = (params) => {
  return http.get(`${base_url}/reception/product`, { params });
};
export const createProductReceptionService = (data) => {
  return http.post(`${base_url}/reception/product`, data);
};
export const editProductReceptionService = (data) => {
  return http.put(`${base_url}/reception/product/${data.id}`, data);
};
export const deleteProductReceptionService = (id) => {
  return http.delete(`${base_url}/reception/product/${id}`);
};
export const changeProductActiveReceptionService = (id) => {
  return http.patch(`${base_url}/reception/product/${id}/active`);
};
// End Product

// Start Reception Info
export const getReceptionInfoReceptionService = () => {
  return http.get(`${base_url}/reception/info`);
};
export const editReceptionInfoReceptionService = (data) => {
  return http.put(`${base_url}/reception/info`, data);
};
export const changeReceptionInfoActiveReceptionService = () => {
  return http.patch(`${base_url}/reception/info/active`);
};
// End Reception Info

// Start Overview
export const getOverviewReceptionService = (params) => {
  return http.get(`${base_url}/reception/overview`, { params });
};
// End Overview
